import { render, staticRenderFns } from "./VesselStat.vue?vue&type=template&id=4aa2361e&scoped=true&"
import script from "./VesselStat.vue?vue&type=script&lang=js&"
export * from "./VesselStat.vue?vue&type=script&lang=js&"
import style0 from "./VesselStat.vue?vue&type=style&index=0&id=4aa2361e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa2361e",
  null
  
)

export default component.exports